const getListActiveAccounts = (data, spaceId, includeHidden) => {
    const accounts = [];
    for (let index = 0; index < data.length; index += 1) {
        const account = { ...data[index] };
        if ('isHidden' in account &&
            (!includeHidden ? !account.isHidden : true) &&
            !account.isClosed &&
            (!spaceId || account.spaceId === spaceId))
            accounts.push(account);
    }
    return accounts;
};
export default getListActiveAccounts;
